module.exports = __webpack_public_path__ + "media/images/solo-100-new@2x-edc85d7d19bb62fb88cb8f1aa2606b2e.webp";